import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppConstants } from '../app-constants.service';
import { CommonSuperComponent } from './common.super';
import { ConfigurationApiService } from '../../generated/api/configuration/configuration.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./common.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class LogoutComponent extends CommonSuperComponent {

    constructor(
        protected override readonly appConstants: AppConstants,
        protected override readonly configurationApiService: ConfigurationApiService
    ) {
        super(appConstants, configurationApiService);
    }

    backToLogin() {
        // hard reload to allow oauth server to redirect to login page
        window.location.href = `${window.location.protocol}//${window.location.host}`;
    }

}
